<nav
	class="relative z-[99] border-b border-b-grey-10 bg-white px-16"
	style="padding-top: env(safe-area-inset-top, 0px)"
>
	<div class="relative mx-auto flex h-[64px] items-center justify-between">
		<button routerLink="{{ routeType.BASE }}" class="flex items-center" [disabled]="!isOnline">
			<img class="header-logo" src="assets/maa-logo.png" alt="MAA" />
		</button>
		<span class="tara-title pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">TARA</span>
		<div class="flex items-center gap-4">
			@if (showActionCenterBell) {
				<button
					type="button"
					class="notification-bell"
					[matMenuTriggerFor]="notificationMenu"
					(menuOpened)="loadActionCenterPreview()"
					aria-label="Action Center notifications"
				>
					<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M15 17H9C9 18.6569 10.3431 20 12 20C13.6569 20 15 18.6569 15 17Z"
							stroke="currentColor"
							stroke-width="1.6"
						/>
						<path
							d="M18 16V11C18 7.68629 15.3137 5 12 5C8.68629 5 6 7.68629 6 11V16L4.5 17.5H19.5L18 16Z"
							stroke="currentColor"
							stroke-width="1.6"
							stroke-linejoin="round"
						/>
					</svg>
					@if (notificationTotal > 0) {
						<span class="notification-badge">{{ notificationTotal }}</span>
					}
				</button>
				<mat-menu #notificationMenu="matMenu" class="notification-menu" xPosition="before">
					<div class="notification-panel">
						<div class="notification-panel__title">Action Center</div>
						@if (notificationItems.length === 0) {
							<div class="notification-empty">No pending requests.</div>
						} @else {
							@for (item of notificationItems; track item.taskId ?? item.trainingAssessmentId) {
								<button type="button" class="notification-item" (click)="openActionCenterItem(item)">
									<span class="notification-item__title">{{ notificationTitle(item) }}</span>
									<span class="notification-item__meta">
										{{ notificationTypeLabel(item) }} · {{ roleLabel(item.role) }}
									</span>
									@if (formatNotificationTime(item.submittedAt)) {
										<span class="notification-item__time">{{ formatNotificationTime(item.submittedAt) }}</span>
									}
								</button>
							}
						}
					</div>
				</mat-menu>
			}
			<div class="indicator flex h-6 w-6 items-center justify-center" [class.offline]="!isOnline"></div>
			<div class="h-9 w-[1px] bg-grey-10"></div>
			@if (user) {
				<div
					class="flex flex-row items-center gap-3"
					[class.cursor-pointer]="isOnline"
					[class.cursor-not-allowed]="!isOnline"
				>
					<span class="hidden text-sm font-medium text-purple-dark md:block">{{ currentRoleLabel }}</span>
					<div
						#profileMenuTrigger="matMenuTrigger"
						(click)="openMenu()"
						[matMenuTriggerFor]="menu"
						class="flex h-12 w-12 cursor-pointer items-center justify-center rounded-md bg-red-light"
					>
						<div class="flex h-11 w-11 items-center justify-center rounded-lg bg-red">
							<app-cbta-avatar
								[name]="user.name"
								[imageUrl]="profilePreview || user.picture"
								[size]="40"
								radius="xl"
							></app-cbta-avatar>
						</div>
					</div>
					<!-- menu -->
					<mat-menu #menu="matMenu" class="menu -my-10">
						<div class="header-menu">
							<div class="mb-3 flex items-center justify-start gap-4 px-3">
								<app-cbta-avatar
									radius="full"
									[size]="44"
									[hasBorder]="true"
									[imageUrl]="profilePreview || user.picture"
									[name]="user.name"
								></app-cbta-avatar>
								<div>
									<!-- <div class="text-sm text-purple-dark font-medium">Felix <span class="text-red">Ruz</span></div> -->
									<div class="text-sm font-medium text-purple-dark">
										{{ user.name }}
									</div>
									<div class="text-xs font-medium text-grey-300">
										{{ user.email }}
									</div>
									<div class="text-xs font-medium text-purple-dark">
										{{ currentRoleLabel }}
									</div>
								</div>
							</div>
							<div class="header-menu-item" (click)="goToProfile()">
								<span>
									<img src="assets/icon_menu_profile.svg" alt="Profile" />
								</span>
								<span>Profile</span>
							</div>
							@if (showSwitchRole) {
								<div class="header-menu-item" (click)="switchRole()">
									<span>
										<img src="assets/icon_menu_switch_roles.svg" alt="Switch Roles" />
									</span>
									<span>Switch Roles</span>
								</div>
							}
							<div class="header-menu-item" (click)="checkForUpdates()">
								<span>
									<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
											stroke="currentColor"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M12 8V12L15 15"
											stroke="currentColor"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</span>
								<span>Check for Updates</span>
							</div>
							<div class="header-menu-version">{{ appVersion }}</div>
							<div class="header-menu-item" (click)="signout()">
								<span>
									<img src="assets/icon_menu_logout.svg" alt="Logout" />
								</span>
								<span>Logout</span>
							</div>
						</div>
					</mat-menu>
				</div>
			}
		</div>
		<!-- <a class="cursor-pointer mr-[12px]" (click)="signout()">Logout</a> -->
	</div>
</nav>
